import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

const MemberTypeToolTip = () => (
    <CustomToolTip
        type="?"
        info={
            <>
                <p className="member-type-tool-tip">
                    Select Self-Administered Songwriter if you write and/or compose your works and manage some or all of
                    your own catalog.
                </p>
                <p className="member-type-tool-tip">
                    Select Publisher if you work at a publishing company and/or are a third-party administrator.
                </p>
                <p className="member-type-tool-tip">Select CMO if you work at a CMO.</p>
            </>
        }
    />
)

export default MemberTypeToolTip
